export class VerifyContractApiResponse {
  verified_datetime: Date;

  constructor(data: any) {
    this.verified_datetime = data.verified_datetime || null;
  }
}
